/**
 * [ROME-8531] The dimensions of report filter options served from the warehouse
 * rather than from the caller's resolved configuration capabilities.
 *
 * One id per (dimension) row group in `platform_mv_reporting_filter_options_by_client`.
 * Difficulty ratings and requirements each appear once per grain because a report
 * filters on the job or the transaction, never both.
 *
 * The `*-requirements-joined` values are whole COMBINATIONS — the comma-joined sorted
 * requirement ids exactly as the report MVs store them (`'floor,frame'`), because that
 * is what the requirements filter selects on. `'unknown'` is a real value there,
 * standing for a job or transaction with no requirements recorded.
 */
export const ids = [
	'job-type',
	'request-type',
	'job-difficulty-rating',
	'transaction-difficulty-rating',
	'ancillary-item',
	'sub-ancillary-item',
	'job-requirements-joined',
	'transaction-requirements-joined',
] as const;
